import { render } from "./AccessDenied.vue?vue&type=template&id=826b8132&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"

import "./AccessDenied.vue?vue&type=style&index=0&id=826b8132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826b8132"]])

export default __exports__